
export enum ColorThemes {
    LIGHT = 'light',
    DARK = 'dark',
    AUTO = 'auto'
}

export enum ColorThemesServer {
    LIGHT,
    DARK,
    AUTO
}

export const DefaultColorTheme = ColorThemes.LIGHT;

export const ColorThemeIcons: any = {
    [ColorThemes.LIGHT]: 'sun',
    [ColorThemes.DARK]: 'moon',
    [ColorThemes.AUTO]: 'sun-fog',
}

export const ColorThemeToServerEnum: any = {
    [ColorThemes.LIGHT]: ColorThemesServer.LIGHT,
    [ColorThemes.DARK]: ColorThemesServer.DARK,
    [ColorThemes.AUTO]: ColorThemesServer.AUTO,
}

export const ColorThemeFromServerEnum: any = {
    [ColorThemesServer.LIGHT]: ColorThemes.LIGHT,
    [ColorThemesServer.DARK]: ColorThemes.DARK,
    [ColorThemesServer.AUTO]: ColorThemes.AUTO,
}
